<template>
    <div class="patient-images">
        <form ref="create-patient-images" @submit.prevent="createImage()">
            <div class="form-name">Завантажити зображення</div>
            <div class="form-group">
                <label class="text">Стать:</label>
                <div class="radio-group">
                    <div class="item">
                        <input type="radio" id="male" name="gender" v-model="isMale" :value="true" required>
                        <label for="male">Чоловік</label><br>
                    </div>
                    <div class="item">
                        <input type="radio" id="female" name="gender" v-model="isMale" :value="false" required>
                        <label for="female">Жінка</label><br>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label class="text">Вік:</label>
                <div class="radio-group">
                    <div class="item">
                        <input type="radio" id="18" name="age" v-model="age" value="18-30" required>
                        <label for="18">18-30</label><br>
                    </div>
                    <div class="item">
                        <input type="radio" id="31" name="age" v-model="age" value="31-40" required>
                        <label for="31">31-40</label><br>
                    </div>
                    <div class="item">
                        <input type="radio" id="41" name="age" v-model="age" value="41-50" required>
                        <label for="41">41-50</label><br>
                    </div>
                    <div class="item">
                        <input type="radio" id="51" name="age" v-model="age" value="51-60" required>
                        <label for="51">51-60</label><br>
                    </div>
                    <div class="item">
                        <input type="radio" id="60" name="age" v-model="age" value="60+" required>
                        <label for="60">60+</label><br>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label class="text">Повне зображення:</label>
                <input type="file" id="file-input" name="file-input" class="file" accept=".png,.svg,.jpg,.jpeg" @change="onFullImgSelected" required>
            </div>

            <div class="form-group">
                <label class="text">Іконка:</label>
                <input type="file" id="file-input" name="file-input" class="file" accept=".png,.svg,.jpg,.jpeg" @change="onIconImgSelected" required>
            </div>

            <div class="form-group buttons">
                <button type="submit" class="btn create">Створити</button>
                <button type="reset" class="btn reset">Скинути</button>
            </div>
        </form>
    </div>    
</template>

<script>
import axios from 'axios';

export default {
    data : () => ({
        img : '',
        icon : '',
        isMale : null,
        age : ''
    }),
    methods : {
        onFullImgSelected(event){
            this.img = event.target.files[0];
        },
        onIconImgSelected(event){
            this.icon = event.target.files[0];
        },
        createImage(){
            let data = new FormData();

            data.append('fullImg', this.img, this.img.name);
            data.append('icon', this.icon, this.icon.name);
            data.append('isMale', this.isMale);
            data.append('age', this.age);


            axios.interceptors.request.use((config) => {
                var token = sessionStorage.getItem('access_token');
                config.headers["Authorization"] = `Bearer ${token}`;
                return config;
            });

            axios.post(location.protocol + '/api/Admin/AddPatientImage', data, {
            headers: {
                'accept': 'application/json',
                'Accept-Language': 'en-US,en;q=0.8',
                'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
                }
            })
            .then(response => {
                console.log(response);
                this.$refs['create-patient-images'].reset();
            }) 
        }
    }
}
</script>

<style lang="scss">
@import '../../../assets/style/form.scss';

.patient-images{
    padding: 40px 60px;
}
</style>